export default "__VITE_ASSET__B5eQUz0M__"